module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-page"
  }, [_c('download-banner'), _vm._v(" "), _c('choose-platform'), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadVpn')) + " " + _vm._s(_vm.currentPlatformInfo.name === 'Ubuntu' ? 'Linux' : _vm.currentPlatformInfo.name) + " " + _vm._s(_vm.$t('client')))]), _vm._v(" "), _c('use-plex-step'), _vm._v(" "), _c('BannerPopup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01adef3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/download/IndexMain.vue
// module id = 1251
// module chunks = 1